import React, { Component, useEffect, useLayoutEffect, useRef, useState } from 'react'
import './Reporttable.css'
import Tablenav from './Tablenav'
import { Modal, OverlayTrigger, Spinner,Table } from 'react-bootstrap';
import { printpdfFun } from '../../utility/excelprint/printpdfFun';
import { setDate } from '../../utility/setDate';
import { AiFillCaretDown } from "react-icons/ai";
import { AiFillCaretRight } from "react-icons/ai";
import { BsFillPinAngleFill } from "react-icons/bs";
import { BiSolidDownArrow } from "react-icons/bi";
import { BiSolidUpArrow } from "react-icons/bi";
import 'tippy.js/dist/tippy.css';
import Tippy from '@tippyjs/react';
import Hexapi from '../../utility/HexAPI/Hexapi';
import { ViewComponent } from '../../components/attachment/ViewComponent';
import { useLocation, useNavigate } from 'react-router';
import { useSelector } from 'react-redux';
import { decodeUrl } from '../../utility/decodesearchurl';
import { Link } from 'react-router-dom';
import { showConfirm } from '../../utility/showconfirm';
import { modifiedSummary } from '../mainsidebar/modifiedsummary';
import { getlinks } from '../mainsidebar/getlinks';
import Loader from '../../components/loader/Loader';
import { useActivate } from 'react-activation';

const Reporttable=(props)=>{

  const[isDataFound,setisDataFound]=useState(false)
  const[isApiHitComplete,setisApiHitComplete]=useState(false)
  const[reportData,setreportData]=useState([])
  const[reportFilters,setreportFilters]=useState(null)
  const[oldData,setolddata]=useState([])
  const[isClearingFilter,setisClearingFilter]=useState(false)
  const[disableexcel,setdisableexcel]=useState(true)
  const[isviewattachment,setisviewattachment]=useState(false)
  const[attachmentId,setattachmentId]=useState("")
  const[filename,setfilename]=useState("")
  const[fileext,setfileext]=useState("")
  const[loadingmodal,setloadingmodal]=useState(false)
  const[querymodaldata,setquerymodaldata]=useState(false)
  const [querydatahtml,setquerydatahtml]=useState(null)
  const[errormsg,seterrormsg]=useState(false)
  const modalBodyRef = useRef(null);
  const [showTooltip, setShowTooltip] = useState(false)
  const [shouldScroll, setShouldScroll] = useState(false);
  const reportDOMRef = useRef(null);
 const [expandedIndexes, setExpandedIndexes] = useState({});
const [detailDataMap, setDetailDataMap] = useState({});
const [searchTerm, setSearchTerm] = useState('');
const [levels, setLevels] = useState([0]);
const [loadingRow, setLoadingRow] = useState(null);
const [lastStickyIndexMap, setLastStickyIndexMap] = useState({});
const [stickyOffsetsMap, setStickyOffsetsMap] = useState({});
const columnRefsMap = useRef({});
const [pinLoading, setPinLoading] = useState({});
const [drillPathDataMap, setDrillPathDataMap] = useState({});
const [isDrillStarted, setIsDrillStarted] = useState(false);
const [visibleLevels, setVisibleLevels] = useState({ 0: true });
const [levelwisehead, setlevelwisehead] = useState({});
const [sortConfigMap, setSortConfigMap] = useState({});
const [sourcequery,setsourcequery]=useState(null)
const [reportname,setreportname]=useState(null)
const [filter,setfilter]=useState(null)
const location=useLocation()
console.log(location,"loactfvgdhjskalon")
 const user = useSelector(
  state => state?.users?.data?.[""]?.[0]
);


const userid = user?.empid ?? null;

const navigate=useNavigate()
const resetReportState = () => {
  setisDataFound(false);
  setisApiHitComplete(false);
  setreportData([]);
  setreportFilters(null);
  setolddata([]);
  setisClearingFilter(false);
  setdisableexcel(true);
  setisviewattachment(false);
  setattachmentId("");
  setfilename("");
  setfileext("");
  setloadingmodal(false);
  setquerymodaldata(false);
  setquerydatahtml(null);
  seterrormsg(false);
  setShowTooltip(false);
  setShouldScroll(false);
  setExpandedIndexes({});
  setDetailDataMap({});
  setSearchTerm('');
  setLevels([0]);
  setLoadingRow(null);
  setLastStickyIndexMap({});
  setStickyOffsetsMap({});
  setPinLoading({});
  setDrillPathDataMap({});
  setIsDrillStarted(false);
  setVisibleLevels({ 0: true });
  setlevelwisehead({});
  setSortConfigMap({});
  setsourcequery(null);
  setreportname(null);
  setfilter(null);
};

    const fetchReportData = () => {
        // setIsLoadComplete(false);
        if (!userid) return;

        const obj = {
            query: `HRApp_Droid_Proc_Organisation_Report_Rights_GetValueV2 @UserID='{0}'`,
            queryArr: [`${userid}`]
        };

        Hexapi(obj, () => fetchReportData(), 1)
            .then(resp => {
              const urlParams = decodeUrl(window.location.search);
              console.log(urlParams,"urlparam")
              const reportname = urlParams?.reportname;
      
                console.log(resp,"resp")
                if(urlParams?.sourcequery){
setsourcequery(decodeURIComponent(urlParams?.sourcequery))
  setreportname(decodeURIComponent(urlParams.name))

   let filterdata = decodeURIComponent(urlParams?.filter).trim();
                console.log(filterdata,"previous")
                let data=''
                if(filterdata.includes("$#12$$")){
                    console.log("yess")
                    data= filterdata.replaceAll("$#12$", "$#12$$");
                    console.log(data,"newdata")
                    setfilter(data)
                }
                }else{
                  if (resp?.reports?.length > 0) {
                    const sourcedata=resp?.reports.filter((res)=>res.description == reportname)[0].sourcequery
                    console.log(sourcedata,"sourcedata")
                    setsourcequery(sourcedata)
                      setreportname(reportname)
                }
                }
                
            })
            .catch(err => console.log(err, "Error"));
    };

const handleSort = (level, key, direction) => {
  setSortConfigMap(prev => ({
    ...prev,
    [`level${level}`]: { key, direction }
  }));

setDrillPathDataMap(prev => {
  const rows = prev[`level${level}`] || [];

  const sortedRows = [...rows].sort((a, b) => {
    const aVal = a[key] ?? "";
    const bVal = b[key] ?? "";

    const dateA = new Date(aVal);
    const dateB = new Date(bVal);

    if (typeof aVal === "number" && typeof bVal === "number") {
      return direction === "asc" ? aVal - bVal : bVal - aVal;
    } else if (!isNaN(dateA) && !isNaN(dateB)) {
      return direction === "asc" ? dateA - dateB : dateB - dateA;
    } else {
      const regex = /(\D*)(\d*)/;
      const [, aPrefix, aNum] = String(aVal).match(regex);
      const [, bPrefix, bNum] = String(bVal).match(regex);

      if (aPrefix === bPrefix) {
        return direction === "asc"
          ? (Number(aNum) || 0) - (Number(bNum) || 0)
          : (Number(bNum) || 0) - (Number(aNum) || 0);
      } else {
        return direction === "asc"
          ? aPrefix.localeCompare(bPrefix)
          : bPrefix.localeCompare(aPrefix);
      }
    }
  });

  return {
    ...prev,
    [`level${level}`]: sortedRows
  };
});


};


useEffect(() => {
  if (reportData && reportData.length > 0) {
    setDrillPathDataMap({
      level0: reportData,
    });
  }
}, [reportData]);

const handleRowExpand = async (level, index, row) => {
  
  const currentExpandedIndex = expandedIndexes[`level${level}`];
  setLoadingRow(`${level}-${index}`);
  await new Promise(resolve => setTimeout(resolve, 0));
  if (currentExpandedIndex === index) {
    setLoadingRow(null)
setVisibleLevels(prev => ({
  ...prev,
  [level + 1]: false
}));

  setLevels(prev => [...prev.slice(0, level + 1)]); 

  const newExpanded = { ...expandedIndexes };
  const newDetailMap = { ...detailDataMap };
  const newlevelwise={...levelwisehead}

  let l = level + 1;

  while (newExpanded[`level${l}`] !== undefined || newlevelwise[`level${l}`] !== undefined){
    delete newExpanded[`level${l}`];
    delete newDetailMap[`level${l}`];
    delete newlevelwise[`level${l}`];
    l++;
  }
  delete newExpanded[`level${level}`];

  setExpandedIndexes(newExpanded);
  setDetailDataMap(newDetailMap);
  setlevelwisehead(newlevelwise)

    const anyDrillActive = Object.keys(newExpanded).some(
    key => Number(key.replace("level", "")) > 0
  );
 
  setIsDrillStarted(anyDrillActive);
  setDrillPathDataMap(prev => {
 
  const newPath = {};

  const freshReportData =reportData && reportData;

  newPath.level0 = level === 0
    ? freshReportData  : (prev.level0);

  for (let i = 1; i <= level - 1; i++) {
    newPath[`level${i}`] = detailDataMap[`level${i}`] || [];
  }

  if(level !== 0){
    newPath[`level${level}`] = detailDataMap[`level${level}`] || [];
  }
  
  return newPath;
});

  setTimeout(() => {
    setLoadingRow(null);
  }, 0);
  return;
}
  
  const newExpanded = { ...expandedIndexes };
  const newDetailMap = { ...detailDataMap };

  newExpanded[`level${level}`] = index;

  let l = level + 1;
  while (newExpanded[`level${l}`] !== undefined) {
    delete newExpanded[`level${l}`];
    delete newDetailMap[`level${l}`];
    l++;
  }

  setExpandedIndexes(newExpanded);
  setDetailDataMap(newDetailMap);

  try {
    const detailRows = await fetchChildData(row,level);

    setDrillPathDataMap(prev => {
      const newPath = {
        ...Object.fromEntries(
          Object.entries(prev).filter(([key]) => Number(key.slice(5)) <= level)
        ),
        [`level${level}`]: [row],
        [`level${level + 1}`]: detailRows,
      };
      if (!newPath.level0) newPath.level0 = reportData;
      return newPath;
    });
   setVisibleLevels(prev => ({
    ...prev,
    [level]: true,
    [level + 1]: true,
  }));
    setDetailDataMap(prev => ({
      ...prev,
      [`level${level + 1}`]: detailRows,
    }));

    setLevels(prev => {
      const updated = [...prev.slice(0, level + 1)];
      if (detailRows.length > 0) {
        updated.push(level + 1);
        setIsDrillStarted(true);
      }
      return updated;
    });
     setLoadingRow(null);
  } catch (err) {
    console.error("Error loading detail rows", err);
  } finally {
    setLoadingRow(null);
  }
};

const fetchChildData = async (query,level) => {
  try {
    const obj = {
      query: query?.drilldownquery,
      queryArr: []
    };
    const resp = await Hexapi(obj,undefined,undefined,true);
    const originalcase = resp?.originalresponseData?.ReportData?.[0] || {};
    const originalKeys = Object.keys(originalcase);
   setlevelwisehead(prev => ({
      ...prev,
      [`level${level + 1}`]: originalKeys
    }));
    return resp?.lowerCasedReports?.reportdata || [];
  } catch (error) {
    console.error("Error fetching child data:", error);
    return [];
  }
};


const getDynamicHeight = (rowCount) => {
  if (rowCount > 50) return "calc(91vh - 220px)";
  if (rowCount > 15) return "calc(91vh - 350px)";
  return "auto";
};


useLayoutEffect(() => {
  const newStickyOffsets = {};

  Object.entries(lastStickyIndexMap).forEach(([level, lastIndex]) => {
    const levelNum = Number(level);
    const refs = columnRefsMap.current[levelNum] || {};
    const offsets = {};
    let totalLeft = 0;

    for (let i = 0; i <= lastIndex; i++) {
      const el = refs[i];
      if (el) {
        offsets[i] = totalLeft;
        totalLeft += el.offsetWidth;
      }
    }

    newStickyOffsets[levelNum] = offsets;
  });

  setStickyOffsetsMap(newStickyOffsets);
}, [lastStickyIndexMap, reportData, detailDataMap])

const handlePinClick = (level, columnIndex) => {
  const key = `${level}-${columnIndex}`;
  setPinLoading(prev => ({ ...prev, [key]: true }));
  setTimeout(() => {
    setLastStickyIndexMap(prev => ({
      ...prev,
      [level]: prev[level] === columnIndex ? null : columnIndex,
    }));
    setPinLoading(prev => ({ ...prev, [key]: false }));
  }, 300);
};

const getDynamicMaxHeight = (rowCount) => {
  if (rowCount > 50) return "calc(91vh - 220px)";
  if (rowCount > 15) return "calc(91vh - 250px)";
  return "calc(91vh - 310px)";
};


const getDrillStyleByLevel = (level) => {
  const indent = 20 * level; 
  const calculatedWidth = 100 - level * 10;
  const maxWidth = `${Math.max(calculatedWidth, 50)}%`;
  
  return {
    marginLeft: `${indent}px`,
    marginRight: `${indent}px`,
    maxWidth,
  };
};

const getOriginalHeaderKey = (key, level) => {
  const headers = levelwisehead[`level${level}`] || [];
  return (
    headers.find(originalKey => originalKey.toLowerCase() === key.toLowerCase()) ??
    key
  );
};


const renderTables = () => {
  return (
    <>
      {levels
        .filter(level => visibleLevels[level])
        .map(level => {
          const currentData = level === 0 ? reportData : detailDataMap[`level${level}`] || [];
          const expandedIndex = expandedIndexes[`level${level}`];
          const isExpanded = expandedIndex !== undefined && expandedIndex !== null;
          const expandedRow = isExpanded ? currentData[expandedIndex] : null;
          const isDrillable = expandedRow?.drilldownquery;
          const lastStickyIndex = lastStickyIndexMap[level] ?? null;
          const stickyOffsets = stickyOffsetsMap[level] || {};

          if (!columnRefsMap.current[level]) columnRefsMap.current[level] = {};

          if (currentData?.[0]?.drilldownquery && lastStickyIndexMap[level] == null) {
            setLastStickyIndexMap(prev => ({ ...prev, [level]: 0 }));
          }

          const sortConfig = sortConfigMap[`level${level}`] || { key: null, direction: null };

          
        let sortedData = [...currentData];

if (sortConfig) {
  const { key, direction } = sortConfig;
  sortedData.sort((a, b) => {
    const aVal = a[key] ?? "";
    const bVal = b[key] ?? "";

    const dateA = new Date(aVal);
    const dateB = new Date(bVal);

    if (typeof aVal === "number" && typeof bVal === "number") {
      return direction === "asc" ? aVal - bVal : bVal - aVal;
    } else if (!isNaN(dateA) && !isNaN(dateB)) {
      return direction === "asc" ? dateA - dateB : dateB - dateA;
    } else {
      return direction === "asc"
        ? String(aVal).localeCompare(String(bVal))
        : String(bVal).localeCompare(String(aVal));
    }
  });
}
          return (
            <div
              key={level}
              style={{
                marginTop: (isDrillStarted || currentData[0]?.drilldownquery) && level !== 0 && "10px",
                marginLeft: (isDrillStarted || currentData[0]?.drilldownquery) && getDrillStyleByLevel(level).marginLeft,
                marginRight: (isDrillStarted || currentData[0]?.drilldownquery) && getDrillStyleByLevel(level).marginRight,
              }}
            >
              <div
                className={`custom-responsive ${(isDrillStarted || currentData[0]?.drilldownquery) ? "custom-responsive-wrapper" : ""}`}
                style={{
                  height: (isDrillStarted || currentData[0]?.drilldownquery)
                    ? (isDrillStarted || isDrillable)
                      ? getDynamicHeight(1)
                      : getDynamicHeight(currentData.length || 0)
                    : "auto",
                  maxHeight: getDynamicMaxHeight(currentData.length || 0),
                  overflow: (isDrillStarted || currentData[0]?.drilldownquery) ? "auto" : "visible",
                }}
              >
                <Table
                  ref={reportDOMRef}
                  bordered
                  size="sm"
                  id="myReportTable"
                  responsive={(currentData[0]?.drilldownquery || isDrillStarted) ? false : true}
                  style={{
                    minWidth: (isDrillStarted || currentData[0]?.drilldownquery)
                      ? getDrillStyleByLevel(level).maxWidth
                      : "auto",
                  }}
                >
                  <thead>
                    <tr className="custom-header-row">
                      {[
                        ...(currentData[0]?.drilldownquery ? ["drilldownquery"] : []),
                        ...Object.keys(currentData[0]).filter(key => key !== "drilldownquery"),
                      ].map((key, i) => {
                        const columnIndex = i;
                        const isSticky = lastStickyIndex !== null && columnIndex <= lastStickyIndex;
                        const isLastSticky = lastStickyIndex === columnIndex;
                        const isDrilldown = key === "drilldownquery";

                        return (
                          <th
                            key={key}
                            ref={el => (columnRefsMap.current[level][columnIndex] = el)}
                            className={`sticky-header ${isSticky ? "sticky-cell" : ""} ${isLastSticky ? "last-sticky-cell" : ""}`}
                            style={{
                              position: "sticky",
                              top: 0,
                              left: isSticky ? stickyOffsets[columnIndex] : "auto",
                              zIndex: isSticky ? 4 : 3,
                              borderRight: isLastSticky ? "4px solid #a6a6a6" : undefined,
                              background: "#e2f3fb",
                              padding: key === "drilldownquery" ? "4px" : undefined,
                              width: key === "drilldownquery" ? "20px" : undefined,
                              textAlign: isDrillable && "center",
                            }}
                          >
                            <div className="header-content" style={{ justifyContent: isDrillable && "center" }}>
                              {!isDrilldown && (
                                <span
                                  style={{ cursor: "pointer", userSelect: "none" , display:"flex" }}
                                  
                                >
                                  {getOriginalHeaderKey(key, level)}
                                  
                                </span>
                              )}
                              <span className="pin-icon" onClick={() => handlePinClick(level, columnIndex)}>
                                {pinLoading?.[`${level}-${columnIndex}`] ? (
                                  <Spinner animation="border" size="sm" style={{ color: "#1250ac", width: "14px", height: "14px" }} />
                                ) : isSticky ? (
                                  <Tippy content="Unfreeze Column" placement="top" delay={[0, 0]} hideOnClick={true}>
                                    <span>
                                      <BsFillPinAngleFill style={{ color: "red", cursor: "pointer", fontSize: "20px" }} />
                                    </span>
                                  </Tippy>
                                ) : (
                                  <Tippy content="Freeze Column" id={`pin-tooltip-${level}-${columnIndex}`} placement="top" delay={[0, 0]} hideOnClick={true}>
                                    <span>
                                      <BsFillPinAngleFill style={{ cursor: "pointer", fontWeight: "900", fontSize: "20px" }} />
                                    </span>
                                  </Tippy>
                                )}
                              </span>
                            
                                  <span className="arrowmain">
  {/* <Tooltip title="Sort" placement="top"> */}
       <BiSolidUpArrow
      className="arrowset"
      onClick={() => handleSort(level, key, "desc")}
      style={{
        color:
          sortConfig?.key === key && sortConfig?.direction === "desc"
            ? "#1250ac"
            : "#1250ac5e",
        cursor: "pointer"
      }}
    />
 {/* </Tooltip> */}
{/* <Tooltip title="Sort" placement="bottom"> */}
  <BiSolidDownArrow
    className="arrowset"
    onClick={() => handleSort(level, key, "asc")}
    style={{
      color:
        sortConfig?.key === key && sortConfig?.direction === "asc"
          ? "#1250ac"
          : "#1250ac5e",
      cursor: "pointer"
    }}
  />
{/* </Tooltip>/ */}
</span>                                  
                            </div>
                          </th>
                        );
                      })}
                    </tr>
                  </thead>

                  <tbody>
                    {(expandedIndex !== undefined ? [sortedData[expandedIndex]] : sortedData).map((row, i) => {
                      const actualIndex = expandedIndex !== undefined ? expandedIndex : i;
                      return (
                        <tr
                          key={actualIndex}
                          onDoubleClick={row?.drilldownquery && loadingRow !== `${level}-${actualIndex}` ? () => handleRowExpand(level, actualIndex, row) : undefined}
                          className={actualIndex % 2 === 0 ? "even-row" : "odd-row"}
                          style={{
                            backgroundColor: expandedIndex === actualIndex ? "#ffffff" : undefined,
                            userSelect: row?.drilldownquery && "none",
                            cursor:
                              row?.drilldownquery && loadingRow === `${level}-${actualIndex}`
                                ? "not-allowed"
                                : row?.drilldownquery
                                ? "pointer"
                                : "default",
                          }}
                        >
                          {row?.drilldownquery && (
                            <td
                              key={`drilldown-icon`}
                              className={`${lastStickyIndex !== null && 0 <= lastStickyIndex ? "sticky-cell" : ""} ${lastStickyIndex === 0 ? "last-sticky-cell" : ""}`}
                              style={{
                                position: lastStickyIndex !== null && 0 <= lastStickyIndex ? "sticky" : "static",
                                left: stickyOffsets[0] || 0,
                                zIndex: 2,
                                whiteSpace: "nowrap",
                                verticalAlign: "middle",
                                background: "inherit",
                                alignContent: "center",
                                padding: "4px",
                                width: "20px",
                                borderRight: lastStickyIndex === 0 ? "4px solid #a6a6a6" : undefined,
                              }}
                            >
                              <span style={{ display: "flex", alignItems: "center" }}>
                                <div className="icon-wrapper" onClick={() => setShowTooltip(false)}>
                                  <Tippy
                                    content={
                                      loadingRow === `${level}-${actualIndex}`
                                        ? "loading..."
                                        : isExpanded
                                        ? "Double-click to Collapse"
                                        : "Double-click to Expand"
                                    }
                                    delay={[0, 0]}
                                    placement="top"
                                    hideOnClick={true}
                                  >
                                    <div className="icon-container" onClick={() => setShowTooltip(false)}>
                                      {loadingRow === `${level}-${actualIndex}` ? (
                                        <Spinner animation="border" size="sm" style={{ color: "#1250ac", width: "14px", height: "14px" }} />
                                      ) : isExpanded ? (
                                        <AiFillCaretDown className="iconright" />
                                      ) : (
                                        <AiFillCaretRight className="iconright" />
                                      )}
                                    </div>
                                  </Tippy>
                                </div>
                              </span>
                            </td>
                          )}

                          {Object.entries(row).map(([key, value], j) => {
                            if (key === "drilldownquery") return null;

                            const columnIndex = row?.drilldownquery ? j + 1 : j;
                            const isSticky = lastStickyIndex !== null && columnIndex <= lastStickyIndex;
                            const isLastSticky = lastStickyIndex === columnIndex;


                            return (
                              <td
                                key={key}
                                className={`${isSticky ? "sticky-cell" : ""}`}
                                style={{
                                  whiteSpace: "nowrap",
                                  position: isSticky ? "sticky" : "static",
                                  left: isSticky ? stickyOffsets[columnIndex] || 0 : "auto",
                                  zIndex: isSticky ? 1 : 0,
                                  background: "inherit",
                                  borderRight: isLastSticky ? "4px solid #a6a6a6" : undefined,
                                  verticalAlign: "middle",
                                }}
                              >
                                 <div
                                 
                                   className='isreportlink'
                                  style={{ borderRadius: "4px", overflow: "hidden", padding: "6px" }}
                                  dangerouslySetInnerHTML={{ __html: typeof value === "string" ? value.replace(/\n/g, "<br/>") : typeof value === "object"?  setDate(value?.date) : value
 }}

                                   onClick={(e) => {
  const anchor = e.target.closest("a"); 
  if (!anchor) return;
  const href = anchor.getAttribute("data-href") || "";
  console.log(href, "hreffffff");
  const htmlString = String(value);
// if(href.includes("urlqueryexec")){
//   handleurlqueryexec(href)
//   return ;
// }
// if(href.includes("urlqueryexec")){
  
// }
  if (href) {
    // e.preventDefault();
    // getlinks(
    //   navigate,
    //   href,
    //   userid,
    //   user?.username,
    //   ()=>setloadingmodal(false),
    //   ()=>setloadingmodal(true),
    //   ()=>handleviewopen(htmlString, href)
    // );
  }
}}
                                />   
                                {/* {
                                   typeof html === "object" ? html : <div
                                  style={{ borderRadius: "4px", overflow: "hidden", padding: "6px" }}
                                  dangerouslySetInnerHTML={{ __html: typeof html === "string" ? html.replace(/\n/g, "<br/>") : html }}
                                />
                                }
                                 */}
                              </td>
                            );
                          })}
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
            </div>
          );
        })}
    </>
  );
};

  useEffect(() => {
    if (querymodaldata  && querydatahtml !== null) {
      setTimeout(() => {
        if (modalBodyRef.current) {
          if(modalBodyRef.current.scrollHeight > 400){
            setShouldScroll(true);
          }
        }
      }, 70);
    }
  }, [querymodaldata, querydatahtml]);


  useEffect(() => {
    const handleSwalOpen = (event) => {
      
        if(event.detail.message==="Swal is opened"){
          seterrormsg(true)
        }
    };

    window.addEventListener("swalOpened", handleSwalOpen);

    return () => {
        window.removeEventListener("swalOpened", handleSwalOpen);
    };
}, [errormsg]);
useEffect(() => {
  const handleSwalClose = (event) => {

      if(event.detail.message==="Swal is closed"){
        props.callback(true);
      }
  };

  window.addEventListener("swalClosed", handleSwalClose);

  return () => {
      window.removeEventListener("swalClosed", handleSwalClose);
  };
}, [props.callback]);



const getSummery=(str)=> {
  if (!str) return null;

  const parser = new DOMParser();
  const doc = parser.parseFromString(str, "text/html");
  const links = Array.from(doc.getElementsByTagName("a"));

  if (links.length == 0) return str;

  const parts = [];
  let lastIndex = 0;
  const rawHtml = str;

  links.forEach((link, idx) => {
    const href = link.getAttribute("href");
    const text = link.textContent;

    const startIndex = rawHtml.indexOf(link.outerHTML, lastIndex);
    if (startIndex > lastIndex) {
      parts.push(rawHtml.slice(lastIndex, startIndex));
    }

    let route ;
    if (href.includes("WorkHistory")) {
      const params = href.split('?')[1].split('&');
      route = `/workhistory?${btoa(`id=${userid}&name=${params[1].split('=')[1]}&shiftid=${params[0].split('=')[1]}`)}`
    } else if (href.includes("Activity")) {
      const params = href.split('?')[1].split('&');
      route = `/activityhistory?${btoa(`id=${userid}&page=activityhistory&activityid=${params[0].split('=')[1]}`)}`
    } else if (href.includes("Ticket")) {
      const params = href.split('?')[1].split('&');
      route = `/tickets?${btoa(`id=${userid}&tid=${params[0].split("=")[1]}`)}`
    } else if (href.includes("RedFlag")) {
      const params = href.split('?')[1].split('&');
      route = `/redflag?${btoa(`id=${params[0].split('=')[1]}`)}`
    } else if (href.includes("UserProfile")) {
      const params = href.split('?')[1].split('&');
      route = `/profile?${btoa(`id=${params[0].split('=')[1]}&page=Userprofile`)}`
    }else if(href.includes("EmpLeaves")){
      const params = href.split('?')[1].split('&');
      route = `/leaves?${btoa(`id=${params[0].split("=")[1]}&name=${params[1].split("=")[1]}`)}`
    }else if(href.includes("EmpApprovals")){
 const params = href.split('?')[1].split('&');
      route = `/approvals?${btoa(`approvaltype=${params[0].split("=")[1]}&approvalstage=${params[1].split("=")[1]}`)}`
    }else if(href.includes("TicketList")){
      route = `/tickets`
    }else if(href.includes("EmpTimeline")){
       const params = href.split('?')[1].split('&');
      route = `/locationtimeline?${btoa(`id=${params[0].split("=")[1]}&shiftid=${params[2].split("=")[1]}&name=${params[1].split("=")[1]}`)}`
    }else if(href.includes("Home")){
      route="/home"
    }

    parts.push(
      <Link
        key={idx}
        to={route}
       
        style={{ color: "blue", textDecoration: "underline" }}
      >
        {text}
      </Link>
    );

    lastIndex = startIndex + link.outerHTML.length;
  });

  if (lastIndex < rawHtml.length) {
    parts.push(rawHtml.slice(lastIndex));
  }

  return parts;
}


  const handleurlqueryexec = async (href, str) => {
    setloadingmodal(true);
    try {
      const params = new URLSearchParams(href.split("?")[1]);
      let query = params.get("query");

      const obj={
        query:`${query}`,
        queryArr:[]
      }

      const resp = await Hexapi(obj);
      if (resp && resp[""] && resp[""][0]) {
        const { command, msg } = resp[""][0];
        if (command === 1 || command === 0) {
          const html = msg;
          setquerydatahtml(html);
          setquerymodaldata(true);
        }
      }
    } catch (error) {
      setloadingmodal(false);
      console.error("Error in handleurlqueryexec:", error);
      setquerymodaldata(false);
      setquerydatahtml(null);
    } finally {
      setloadingmodal(false);
    }
  };


useEffect(()=>{
  if(!userid) return 
fetchReportData()
},[userid,location.search])
const handleviewopen = async (str, url) => {
  console.log(str,"strrrrrrr")
  console.log("gfhdjks")
  console.log(url,"urlssssssssss")
  setloadingmodal(true)
  
  try {
    ;
    const fileParts = str.split('.');
    const fileExt = '.' + fileParts.at(-1);
    const fileName = fileParts.slice(0, -1).join('.');

    let attachmentId = null;
    const params = new URLSearchParams(url.split("?")[1]);
    attachmentId = params.get("attachmentids");

    if (attachmentId) {
        setattachmentId(attachmentId);
        setfilename(fileName);
        setfileext(fileExt);
        setisviewattachment(true);
    }

    setloadingmodal(false);
  } catch (error) {
    console.log(error,"error")
  }
};

  useEffect(()=>{
    if(!userid || !sourcequery) return;
    if(filter != null){
      getfilterdata(-1)
      applyFilterFun(filter)
    }else{
      clearFilters(-1)
    }
  },[sourcequery,filter])

  const getfilterdata=async(filterstr)=>{
    if(!userid)  return;
    if (sourcequery != undefined && sourcequery != null && filterstr == -1) {
      setisClearingFilter(true)
       let queryString = (sourcequery).replace('<UserID>', `{0}`).replace('<filters>', '{1}').replace("N'", "'")
   
       queryString = queryString + ",@OnlyFilterData='{2}'"
       let obj = {
         query: queryString,
         queryArr: [`${userid}`, `-1`, `1`]
       }
       if (filterstr == -1) {
         const resp = await Hexapi(obj,()=>getfilterdata(filterstr),1)
        console.log(resp,"resp")
         if (resp.filters != undefined) {
       
           let arrayfilter=filter.split("$#12$$")

          resp.filters.forEach((filter, index) => {
            if (arrayfilter[index]) {
              filter.defval = `${arrayfilter[index]}`;
            }
          });
 
           setreportFilters(resp.filters)
         }
          else {
           setreportFilters(null)
         }
       }
     }
  }

  const clearFilters = async (filterstr) => {
    if(!userid) return 
    try {
        seterrormsg(false);
        setisApiHitComplete(false);
        setdisableexcel(true);
        setisClearingFilter(true);

        if (sourcequery) {  
            let queryString = (sourcequery).replace('<UserID>', `{0}`).replace('<filters>', '{1}').replace("N'", "'")
            let obj1 = {
                query: queryString,
                queryArr: [`${userid}`, `${filterstr}`],
            };

            let apiCalls = [Hexapi(obj1, () => clearFilters(filterstr),1,true)];

            if (filterstr == -1) {
                let queryString2 = queryString + ",@OnlyFilterData='{2}'";
                let obj2 = {
                    query: queryString2,
                    queryArr: [`${userid}`, `-1`, `1`],
                };

                apiCalls.push(Hexapi(obj2, () => clearFilters(filterstr),1));
            }
            const results = await Promise.allSettled(apiCalls);
            console.log(results,"results")
            if (results[0].status === "fulfilled") {
                const resp1 = results[0].value;
                setreportData([]);
                setisDataFound(false);

                if ( resp1 && resp1?.lowerCasedReports?.reportdata) {
                    setreportData(resp1?.lowerCasedReports?.reportdata);
                    setisDataFound(true);
                    setdisableexcel(false);
const originalcase = resp1?.originalresponseData?.ReportData?.[0] || {};

const originalKeys = Object.keys(originalcase);

setlevelwisehead({
  level0: originalKeys,
});

                } else if (resp1?.sqlerrors) {
                    seterrormsg(true);
                }
            } else {
                console.error( results[0].reason.message);
                if (results[0].reason.message === "User closed the retry dialog") {
                  props.callback(true);
              }
                seterrormsg(true);
            }


            if (filterstr == -1 && results.length > 1) {
                if (results[1].status === "fulfilled") {
                    const resp2 = results[1].value;
                    if (resp2?.filters) {
                        setreportFilters(resp2.filters);
                    } else if (resp2?.sqlerrors) {
                        seterrormsg(true);
                    } else {
                        setreportFilters(null);
                    }
                } else {
                    console.error("Second API call failed:", results[1].reason);
                    seterrormsg(true);
                    if (results[1].reason.message === "User closed the retry dialog") {
                      props.callback(true);
                  }
                }
            }
        }

        setisApiHitComplete(true);
        setisClearingFilter(false);
    } catch (error) {
        console.log(error, "error");

        if (error.message === "Network Error") {
            console.log("Network issue detected.");
            seterrormsg(true);
        }
    }
};

 const getOldData =(oldData)=> {
  setolddata(oldData)
  }
 const applyFilterFun=(data)=> {
    clearFilters(data)
  }


useEffect(() => {
  const handlePrintShortcut = (e) => {
    if ((e.ctrlKey || e.metaKey) && e.key === "p") {  
      e.preventDefault();
      const domNode = reportDOMRef.current;
  const table = reportDOMRef.current;
  if (!table) return [];

  const rows = table.querySelectorAll("tbody tr");
  const data = [];
  rows.forEach((row) => {
    const rowData = [];
    const cells = row.querySelectorAll("td");
    cells.forEach((cell) => {
      rowData.push(cell.textContent.trim());
    });
    data.push(rowData);
  });
      if (!domNode || domNode.innerHTML.trim() === "") {
        console.warn("Nothing to print.");
        return;
      }
      printpdfFun(data, props.tableheader);
    }
  };

  window.addEventListener("keydown", handlePrintShortcut);
  return () => {
    window.removeEventListener("keydown", handlePrintShortcut);
  };
}, []);


    return (
      <div className="container-fluid">
        <Tablenav
        resetReportState={resetReportState}
          clearFilters={(data) => clearFilters(data)}
          header={reportname}
          userid={userid}
          getResultFromFilter={(data) => applyFilterFun(data)}
          fetchrsurl={props.url}
          levelwisehead={levelwisehead}
          reportData={reportData.length>0 && reportData}
          filters={reportFilters && reportFilters}
          oldData={oldData}
          getOldData={getOldData.bind(this)}
          disableexcel={reportData.length > 0 ? true : false}
          hide={props.hide}
          searcht={searchTerm}
          drillPathDataMap={drillPathDataMap}
          setSearchTerm={setSearchTerm}
        />
        { !errormsg ?
          isApiHitComplete ?
            isDataFound ?
             <div
 className={`report-container ${
    reportData && reportData[0]?.drilldownquery ? "drilldown-active" : "drilldown-inactive"
  }`}
>
  {renderTables()}
</div>

              :
              <div className="container-fluid" style={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "90vh" }}>
                <h4 style={{color:"#ff6d00" }}>No Data</h4>
              </div>
            :
            <div className="container-fluid" style={{ display: 'flex', justifyContent: "center", alignItems: "center", height: "90vh" }}>
                <Loader/>
            </div>: ""
        }
       {loadingmodal &&
        <div className="loading-overlay">
            <Loader/>
        </div>
}

{ querymodaldata && <Modal centered  show={querymodaldata} onHide={()=>setquerymodaldata(false)} style={{backgroundColor:'rgba(0, 0, 0, 0.41)'}} backdrop={false} keyboard={false}>
  <Modal.Body
  ref={modalBodyRef}
        style={{
          maxHeight: shouldScroll ? "500px" : "auto",
          overflowY: shouldScroll ? "scroll" : "visible",
          textAlign:  querydatahtml !== null &&  querydatahtml ==='No leads' && "center"
        }}
        className='scrollable-content2'
>
  
     {querydatahtml !==null && 
                                   typeof querydatahtml === "object" ? querydatahtml : <div
                                  style={{ borderRadius: "4px", overflow: "hidden", padding: "6px" }}
                                  dangerouslySetInnerHTML={{ __html: typeof querydatahtml === "string" ? querydatahtml.replace(/\n/g, "<br/>") : querydatahtml }}
                                />
                                }

  </Modal.Body>
<Modal.Footer style={{justifyContent:"flex-end" , padding:"10px"}}>
  <div style={{display:"flex" , justifyContent:"flex-end" , alignContent:"center"}}>
    <p onClick={()=>{
      setquerydatahtml(null)
      setquerymodaldata(false)}} className='btnquery' style={{marginBottom:"0px"}} >OK</p>
  </div>
</Modal.Footer>
  </Modal>}
        {/* {isviewattachment && <ViewComponent userid={userid} passid={attachmentId} ids={userid} filenames={filename} fileExt={fileext} closeModal={() => setisviewattachment(false)} isViewModalOpen={isviewattachment} />} */}
      </div>
    )
}
export default Reporttable